import { render, staticRenderFns } from "./MaterialHistory.vue?vue&type=template&id=3d53d033"
import script from "./MaterialHistory.vue?vue&type=script&lang=js"
export * from "./MaterialHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports